import { render, staticRenderFns } from "./DedicatedNumberPaymentCheckout.vue?vue&type=template&id=62b95462&scoped=true&"
import script from "./DedicatedNumberPaymentCheckout.vue?vue&type=script&lang=js&"
export * from "./DedicatedNumberPaymentCheckout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b95462",
  null
  
)

export default component.exports